"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dateComparison_1 = __importDefault(require("./dateComparison"));
exports.default = (date, range) => (0, dateComparison_1.default)(date, range.from) !== -1 &&
    (0, dateComparison_1.default)(date, range.to) !== 1;
//# sourceMappingURL=inDateRange.js.map